import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import Item from './Item';
import AccordionContainer from './styles/AccordionStyled';
import AccordionColumn from './styles/AccordionColumnStyled';

const Accordion = ({ data, selectedAccount }) => {
  // NO TOCAR afecta experiencia de usuario en despliegue de datos
  // se utilizan 2 columnas en lugar de una grid o flex para asegurar que se abra el detalle
  // de cada factura de forma independiente, sin mover al componente vecino.
  const isMedium = useMediaQuery({
    query: '(min-width: 768px)',
  });
  const items = data
    .slice(0, 6)
    .map((item, index) => (
      <Item
        data={item}
        key={index}
        isToggled={index === 0}
        selectedAccount={selectedAccount}
      />
    ));

  return (
    <AccordionContainer>
      {isMedium ? (
        <>
          <AccordionColumn>
            {items.filter((el, idx) => idx % 2 === 0)}
          </AccordionColumn>
          <AccordionColumn>
            {items.filter((el, idx) => idx % 2 === 1)}
          </AccordionColumn>
        </>
      ) : (
        <AccordionColumn>{items}</AccordionColumn>
      )}
    </AccordionContainer>
  );
};

Accordion.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.number,
      documentId: PropTypes.string,
      month: PropTypes.string,
    })
  ),
  selectedAccount: PropTypes.string.isRequired,
};

Accordion.defaultProps = {
  data: [
    {
      amount: '',
      documentId: '',
      month: '',
    },
  ],
};

export default Accordion;
